interface StoreTestimonials {
  id: number;
  title: string;
  name: string;
  layout: Record<string, unknown>;
  testimonials: TestimonialData[];
}

interface TestimonialData {
  id: string;
  name: string;
  image: string | null;
  feedback: string;
  publish: boolean;
}

export const processResponse = (storeTestimonials: Record<string, unknown>): StoreTestimonials => {
  const testimonials = (storeTestimonials.testimonials as Record<string, never>[])?.map((testimonial) => ({
    id: testimonial.id,
    name: testimonial.name,
    image: testimonial.image,
    feedback: testimonial.feedback,
    publish: testimonial.publish,
  }));
  return {
    id: storeTestimonials.id,
    title: storeTestimonials.title,
    name: storeTestimonials.name,
    layout: storeTestimonials.layout,
    testimonials,
  };
};
